import { render, staticRenderFns } from "./aixintiao.vue?vue&type=template&id=5d9401c6&scoped=true&"
import script from "./aixintiao.vue?vue&type=script&lang=js&"
export * from "./aixintiao.vue?vue&type=script&lang=js&"
import style0 from "./aixintiao.vue?vue&type=style&index=0&id=5d9401c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9401c6",
  null
  
)

export default component.exports